import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import { Box, IconButton, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TabItemProps } from "./types";

export const DraggableTabItem: React.FC<TabItemProps> = ({
  tab,
  index,
  translate,
  toggleVisibility,
}) => {
  return (
    <Draggable draggableId={tab.path} index={index}>
      {(provided) => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            padding: "8px",
            display: "flex",
            alignItems: "center",
            borderRadius: "4px",
            ...provided.draggableProps.style,
          }}
        >
          <Typography
            {...provided.dragHandleProps}
            style={{
              color: tab.hidden ? "#aaa" : "inherit",
              textDecoration: tab.hidden ? "line-through" : "none",
            }}
          >
            {translate(tab.label)}
          </Typography>

          <IconButton size="small" onClick={() => toggleVisibility(tab.path)}>
            {tab.hidden ? (
              <VisibilityOff fontSize="small" />
            ) : (
              <Visibility fontSize="small" />
            )}
          </IconButton>
        </Box>
      )}
    </Draggable>
  );
};
